<template>
  <!-- 餐饮-取餐 -->
  <div class="wrapper pb-2x flex-start flex-col">
    <panel-head :close="false" title="取餐"></panel-head>
    <div
      class="container mt-2x flex-grow"
      v-permission="'appCateringTakeFoods'"
    >
      <KeyboardPro @ok="ok" v-model="numbers">
        <template v-slot:input="{ confirm }">
          <a-input
            size="large"
            allow-clear
            v-model="numbers"
            placeholder="取餐码/手机号/订单号查询"
            @pressEnter="confirm()"
          >
            <a-icon
              class="primary"
              slot="prefix"
              type="search"
              style="font-size:24px"
            />
            <a-icon
              class="primary"
              slot="suffix"
              type="scan"
              style="font-size: 24px"
            />
          </a-input>
        </template>
      </KeyboardPro>
    </div>
  </div>
</template>

<script>
import PanelHead from "../../../components/common/PanelHead.vue";
import KeyboardPro from "../../../components/common/KeyboardPro.vue";
import { orderTakefood } from "../../../api/search";

import { clearScanCode, scanCode } from "../../../utils/hardware";

export default {
  components: { PanelHead, KeyboardPro },
  name: "TakeFood",
  data() {
    return {
      numbers: ""
    };
  },
  created() {
    //先调用方法把扫码类型改成2，再监听硬件扫码方法scanCode
    // try {
    //   window.test.optScan("2");
    //   window.scanCode = this.scanCode;
    // } catch (error) {
    //   console.log(error);
    // }
    scanCode(this.scanCode);
  },

  beforeDestroy() {
    clearScanCode();
  },

  methods: {
    scanCode(res) {
      this.numbers = res;
      this.ok();
    },
    ok() {
      if (!this.numbers) {
        this.$message.warning("请先输入取餐码/手机号/订单号");
        return;
      }
      orderTakefood({
        keyword: this.numbers
      })
        .then(res => {
          if (res.length > 0) {
            this.$router.push({
              path: "/catering/TakeFoodList",
              query: {
                numbers: this.numbers
              }
            });
            sessionStorage.setItem("pickList", JSON.stringify(res));
          } else {
            this.$message.warning("未查询到订单信息");
          }
        })
        .catch(() => {});
    }
  }
};
</script>

<style lang="less" scoped>
.container {
  padding-top: 60px;
}
</style>
